"use client";

import type { UserId } from "@nimble/datamodel/types/userId";
import { CACHE_REVALIDATE_5_MIN_MS } from "@nimble/react-requests/api-clients/caching-strategy";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import {
  getInvitations,
  InvitationsResponse,
} from "@/lib/api-clients/recommendation-api-client";

export function getInvitationsQueryKey(
  userId: UserId,
  invitesCacheKey?: number,
) {
  return ["invitations", userId, invitesCacheKey] as const;
}

interface UseInvitationsOptions
  extends Omit<UseQueryOptions<InvitationsResponse>, "queryKey" | "queryFn"> {
  invitesCacheKey?: number;
}

export function useInvitations(
  userId: UserId,
  options?: UseInvitationsOptions,
) {
  const { invitesCacheKey, ...queryOptions } = options ?? {};

  return useQuery({
    queryKey: getInvitationsQueryKey(userId, invitesCacheKey),
    queryFn: async () => {
      const response = await getInvitations(userId);
      return response.data;
    },
    staleTime: CACHE_REVALIDATE_5_MIN_MS,
    ...queryOptions,
  });
}
